import { Component } from '@angular/core';
import { ProfileComponent as PortfolioComponent } from './portfolio.component';

@Component({
  selector: 'eid-portfolio-mobile',
  templateUrl: './portfolio.mobile.component.html',
  styleUrls: ['./portfolio.mobile.component.scss']
})
export class PortfolioMobileComponent extends PortfolioComponent {}
